import React, { useState, useEffect } from 'react';
import Wrapper from './styles';
import { Link, useHistory } from 'react-router-dom';
import { useUserContext } from '../../context/user_context';
import { toast } from 'react-toastify';
import Button from '../../components/Button';
import ResetPasswordPage from '../ResetPasswordPage';

function ForgotPasswordPage() {
  const { forgotPassword, updateUserDetails } = useUserContext();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResetPageOpen, setIsResetPageOpen]=useState(false)
const history=useHistory()
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      return toast.error('Please enter e-mail');
    }
    setIsResetPageOpen(true)

  
  };

  useEffect(() => {
    document.title = 'Team Rugby | Forgot Password';
  }, []);

  return (
    <Wrapper className='page-100'>
      {!isResetPageOpen ? <div>
        <div className='title'>
          <h2>Forgot</h2>
        </div>
        <form onSubmit={handleSubmit}>
          {/* email */}
          <div className='form-control'>
            <input
              type='email'
              className='input'
              placeholder='Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {/* end email */}

          <Button
            disabled={isSubmitting}
            type='submit'
            className='btn forgot-btn'
          >
            submit
          </Button>

          <div className='seperator'>
            <hr />
            <span>or</span>
          </div>
          <div className='links'>
            <Link to='/login' className='link'>
              login
            </Link>
          </div>
        </form>
      </div>:<ResetPasswordPage email={email}/>}
    </Wrapper>
  );
}

export default ForgotPasswordPage;
